/**
 * Isi halaman Dokumentasi.
 *
 * Dipisah dari komponennya supaya menyunting teks tidak menuntut menyentuh
 * JSX, dan supaya perubahan isi terlihat jelas di riwayat git tanpa
 * tercampur perubahan tampilan.
 *
 * ── Nada tulisan ─────────────────────────────────────────────────────────
 *
 * Pembacanya PELANGGAN, bukan orang yang ikut membangun Crawel. Ia sedang
 * mencoba menyelesaikan pekerjaannya, bukan sedang menilai rancangan kita.
 * Karena itu:
 *
 *   Tulis apa yang bisa ia lakukan, bukan kenapa kami membangunnya begitu.
 *   Alasan teknis hanya disebut kalau ia mengubah cara ia bertindak.
 *
 *   Sapa dengan "Anda", ramah tetapi tidak terlalu santai. Ini alat kerja.
 *
 *   Kalimat pendek. Kata kerja di depan: "Tempel alamatnya", bukan "Alamat
 *   halaman dapat ditempelkan".
 *
 *   Kalau ada batasan, sebutkan sekaligus jalan keluarnya.
 *
 * Tiap blok punya `t` yang menentukan cara ia dirender:
 *   p       paragraf
 *   h       subjudul
 *   kode    blok kode dengan tombol salin
 *   tabel   { kepala: [], baris: [[]] }
 *   daftar  daftar berpoin
 *   catatan { nada: 'info' | 'peringatan' }
 */

export const BAGIAN = [
  {
    id: 'mulai',
    judul: 'Mulai Cepat',
    ringkas: 'Lima menit dari daftar akun sampai punya data pertama.',
    isi: [
      {
        t: 'p',
        isi: 'Crawel mengambil data dari halaman web dan menyimpannya rapi untuk Anda, terjadwal, tanpa perlu menulis kode. Tempel alamat halamannya, dan Crawel mencari sendiri mana bagian datanya.',
      },
      { t: 'h', isi: 'Langkah pertama' },
      {
        t: 'daftar',
        isi: [
          'Buka Scraping, lalu Buat Scraping.',
          'Pilih mode Otomatis dan tempel alamat halaman yang isinya berupa daftar, misalnya daftar produk atau daftar berita.',
          'Tunggu sebentar. Crawel mendeteksi sendiri, tidak ada tombol yang perlu Anda tekan.',
          'Periksa kolom yang ditemukan. Buang yang tidak Anda perlukan, ganti namanya kalau perlu.',
          'Simpan, lalu tekan Jalankan Sekarang.',
        ],
      },
      {
        t: 'p',
        isi: 'Hasilnya muncul dalam hitungan detik untuk halaman biasa. Dari sana Anda bisa mengunduhnya, menyimpannya sebagai berkas, atau langsung menganalisanya.',
      },
      {
        t: 'catatan',
        nada: 'info',
        isi: 'Halaman yang paling cocok adalah yang isinya berupa daftar berulang. Halaman profil tunggal atau artikel tanpa daftar tidak akan menghasilkan apa-apa.',
      },
      { t: 'h', isi: 'Hasilnya kosong?' },
      {
        t: 'p',
        isi: 'Buka Scraping Saat Ini, klik nama pekerjaannya, lalu lihat lognya. Log menyebutkan apa yang terjadi di tiap langkah.',
      },
      {
        t: 'kode',
        isi: `info  Mulai crawl https://contoh.com (mesin=auto, maks 2 halaman)
info  Selektor item: .produk
info  Halaman 1/2: mengambil https://contoh.com
info  Mesin yang dipakai: static (11.064 byte terunduh)
warn  Tidak ada baris yang cocok dengan selektor pada halaman ini.`,
      },
      {
        t: 'p',
        isi: 'Kalau baris terakhir itu muncul, biasanya halaman tersebut menyusun isinya dengan JavaScript. Buka Sunting Konfigurasi, ganti Mesin Crawl dari Otomatis menjadi Browser, lalu jalankan lagi. Itu menyelesaikan sebagian besar kasus.',
      },
    ],
  },

  {
    id: 'scraping',
    judul: 'Empat Cara Mengambil Data',
    ringkas: 'Pilih yang paling sesuai dengan kebutuhan Anda.',
    isi: [
      {
        t: 'tabel',
        kepala: ['Mode', 'Pilih ini kalau', 'Yang Anda isi'],
        baris: [
          ['Otomatis', 'Anda ingin cepat selesai. Ini pilihan sebagian besar orang', 'Alamat halamannya'],
          ['AI', 'Nama kolom hasil deteksi kurang enak dibaca', 'Alamat halaman, plus kunci Anthropic Anda'],
          ['Pustaka', 'Situs yang Anda tuju sudah kami siapkan formulirnya', 'Pilih situs dan bagiannya, isi parameternya'],
          ['Manual', 'Anda paham CSS dan ingin kendali penuh', 'Selektor CSS pilihan Anda'],
        ],
      },
      { t: 'h', isi: 'Mode AI dan data Anda' },
      {
        t: 'p',
        isi: 'Mode AI hanya merapikan nama kolom. Yang dikirim ke model cuma nama tebakan dan beberapa contoh nilai. Isi halaman tidak pernah ikut, dan kunci yang dipakai adalah kunci Anda sendiri, jadi biayanya jelas milik siapa.',
      },
      {
        t: 'p',
        isi: 'Kalau AI-nya bermasalah, deteksinya tetap berhasil dengan nama biasa. Anda tidak akan kehilangan hasil.',
      },
      { t: 'h', isi: 'Mengatur cakupan crawl' },
      {
        t: 'tabel',
        kepala: ['Pengaturan', 'Artinya bagi Anda'],
        baris: [
          ['Maksimal halaman', 'Berapa halaman yang diikuti lewat tombol berikutnya'],
          ['Jeda antar permintaan', 'Waktu tunggu antar halaman'],
          ['Kedalaman', 'Seberapa jauh tautan di dalam halaman ikut ditelusuri'],
          ['Mesin crawl', 'Otomatis, Statis yang lebih cepat, atau Browser untuk halaman yang butuh JavaScript'],
        ],
      },
      {
        t: 'catatan',
        nada: 'peringatan',
        isi: 'Crawel selalu menghormati robots.txt dan menjaga jeda antar permintaan. Ini membuat pekerjaan Anda berjalan lancar dalam jangka panjang, karena situs yang merasa dihantam akan memblokir Anda.',
      },
    ],
  },

  {
    id: 'hasil',
    judul: 'Menyimpan dan Membagikan Hasil',
    isi: [
      {
        t: 'p',
        isi: 'Hasil crawl tersimpan di dalam pekerjaannya. Untuk menjadikannya berkas, buka detail pekerjaan lalu tekan Simpan ke Cloud, dan pilih formatnya: CSV, JSON, atau NDJSON.',
      },
      {
        t: 'p',
        isi: 'Berkasnya masuk ke Penyimpanan Pribadi. Di sana Anda bisa melihat isinya sebagai tabel, memindahnya antar folder, menggantinya nama, mengunduhnya, mengirimnya ke orang lain, atau menerbitkannya ke Data Publik.',
      },
      { t: 'h', isi: 'Mengirim berkas ke orang lain' },
      {
        t: 'p',
        isi: 'Penerima yang membuat kodenya, lalu memberikannya kepada pengirim. Begini urutannya:',
      },
      {
        t: 'daftar',
        isi: [
          'Penerima menekan Terima, memilih folder tujuan, lalu mendapat kode yang berlaku 24 jam.',
          'Kode itu diberikan kepada pengirim lewat cara apa pun.',
          'Pengirim menekan Kirim, memasukkan kode, lalu memilih berkas yang dikirim.',
        ],
      },
      {
        t: 'p',
        isi: 'Dengan begitu berkas selalu mendarat di folder yang Anda pilih sendiri, dan tidak ada yang bisa mengirimi Anda berkas tanpa kode dari Anda.',
      },
      { t: 'h', isi: 'Menjalankan ulang tanpa data ganda' },
      {
        t: 'p',
        isi: 'Menjalankan pekerjaan yang sama dua kali tidak akan menggandakan data Anda. Baris yang sudah pernah tersimpan dikenali dan dilewati. Ini berguna untuk pekerjaan terjadwal, karena halaman pertama sebuah situs hari ini dan besok biasanya banyak bertumpang tindih.',
      },
    ],
  },

  {
    id: 'jadwal',
    judul: 'Menjalankan Otomatis',
    isi: [
      {
        t: 'p',
        isi: 'Pekerjaan bisa berjalan sendiri tanpa Anda buka. Aturlah lewat halaman Scheduler, atau lewat panel Penjadwalan saat membuat pekerjaan.',
      },
      {
        t: 'tabel',
        kepala: ['Frekuensi', 'Tersedia mulai paket'],
        baris: [
          ['Mingguan dan bulanan', 'Starter'],
          ['Per jam dan harian', 'Pro'],
        ],
      },
      {
        t: 'p',
        isi: 'Jumlah jadwal yang bisa aktif bersamaan mengikuti paket Anda, dan bisa ditambah lewat add-on tanpa perlu naik paket.',
      },
      { t: 'h', isi: 'Memberi nama berkas otomatis' },
      {
        t: 'p',
        isi: 'Pekerjaan terjadwal menghasilkan berkas berulang kali. Sisipkan penanda waktu di dalam namanya supaya hasil kemarin tidak tertimpa.',
      },
      {
        t: 'tabel',
        kepala: ['Penanda', 'Hasilnya', 'Cocok untuk'],
        baris: [
          ['{d2d}', '20260821', 'harian'],
          ['{m2m}', '202608', 'bulanan'],
          ['{h2h}', '20260821_1430', 'per jam'],
        ],
      },
      {
        t: 'p',
        isi: 'Contohnya, produk-{d2d} menjadi produk-20260821.csv. Semuanya memakai waktu Jakarta, dan pratinjaunya langsung muncul saat Anda mengetik.',
      },
      {
        t: 'catatan',
        nada: 'info',
        isi: 'Kalau ada gangguan yang membuat jadwal terlewat lebih dari enam jam, Crawel melewatinya dan lanjut ke jadwal berikutnya, bukan menjalankan semuanya sekaligus. Butuh hasilnya sekarang juga? Tekan Jalankan Sekarang.',
      },
    ],
  },

  {
    id: 'analisa',
    judul: 'Menganalisa Data Anda',
    isi: [
      {
        t: 'p',
        isi: 'Menu Analisa punya tiga bagian dengan alur yang sama: pilih berkas, pilih analisa, isi parameter, jalankan. Hasilnya berupa laporan berisi angka, tabel, dan grafik yang tersimpan dan bisa dibuka kapan saja.',
      },
      {
        t: 'tabel',
        kepala: ['Bagian', 'Gunanya'],
        baris: [
          ['EDA', 'Memahami isi data: statistik, kelengkapan kolom, sebaran, dan korelasi'],
          ['Analytics', 'Menyusun laporan dari data yang sudah Anda pahami'],
          ['Machine Learning', 'Melatih model lalu melihat seberapa baik hasilnya'],
        ],
      },
      {
        t: 'p',
        isi: 'Hasil EDA juga tersimpan sebagai berkas di Penyimpanan Pribadi, sehingga bisa dipakai kembali sebagai bahan analisa berikutnya.',
      },
      {
        t: 'catatan',
        nada: 'info',
        isi: 'Daftar analisanya kosong? Berarti belum ada yang tersedia untuk bagian itu. Analisa disiapkan oleh tim, jadi kabari kami kalau ada yang Anda butuhkan.',
      },
    ],
  },

  {
    id: 'paket',
    judul: 'Paket, Kuota, dan Add-on',
    isi: [
      {
        t: 'p',
        isi: 'Tiap paket punya batas jumlah baris, jumlah pekerjaan, penyimpanan, dan penjadwalan. Sisa kuota Anda terlihat di halaman Paket & Tagihan, lengkap dengan tanggal kuota berikutnya dimulai.',
      },
      { t: 'h', isi: 'Cara kerja kuota' },
      {
        t: 'daftar',
        isi: [
          'Kuota berulang tiap bulan. Kalau Anda berlangganan tanggal 1 Januari, kuotanya kembali penuh tanggal 1 Februari.',
          'Membeli paket yang sama saat masih berlaku akan menambah masa aktifnya, bukan menggantinya.',
          'Naik ke paket yang lebih tinggi memulai periode baru dengan kuota penuh.',
        ],
      },
      { t: 'h', isi: 'Kalau kuota habis di tengah bulan' },
      {
        t: 'p',
        isi: 'Data yang sudah terkumpul tetap aman dan bisa Anda unduh seperti biasa. Yang berhenti hanya pengumpulan data baru. Anda punya dua pilihan: naik paket, atau menambah kuota lewat add-on tanpa mengganti paket.',
      },
      { t: 'h', isi: 'Add-on' },
      {
        t: 'p',
        isi: 'Add-on menambah kuota di atas paket yang sedang berjalan. Ada empat jenis: tambahan baris, penyimpanan, jumlah pekerjaan, dan jumlah jadwal.',
      },
      {
        t: 'daftar',
        isi: [
          'Bisa dibeli bersama paket, atau kapan saja selama paket berbayar Anda masih aktif.',
          'Berlaku sampai masa aktif paket Anda berakhir. Kalau dibeli di tengah periode, harganya dihitung sesuai sisa hari.',
          'Boleh beli lebih dari satu. Butuh 20.000 baris tambahan? Ambil empat add-on 5.000.',
        ],
      },
      { t: 'h', isi: 'Membayar' },
      {
        t: 'p',
        isi: 'Pilih paket atau add-on, masukkan kode diskon kalau ada, lalu pilih cara membayar. QRIS bisa dibayar dari hampir semua aplikasi dompet digital dan mobile banking, jadi itu pilihan paling praktis. Tersedia juga transfer virtual account, dompet digital, dan kartu kredit.',
      },
      {
        t: 'p',
        isi: 'Kuota Anda bertambah otomatis begitu pembayaran diterima. Kalau halaman pembayaran keburu tertutup, buka lagi tagihannya dari Paket & Tagihan dan lanjutkan dari sana.',
      },
    ],
  },

  {
    id: 'api',
    judul: 'Menghubungkan ke Program Lain',
    ringkas: 'API Crawel, tersedia mulai paket Growth.',
    isi: [
      {
        t: 'p',
        isi: 'Kalau Anda ingin menarik hasil scraping langsung ke skrip, notebook, atau aplikasi Anda sendiri, pakai API-nya.',
      },
      { t: 'h', isi: 'Alamat dasar' },
      { t: 'kode', isi: 'https://crawel.com/api/v1' },
      { t: 'h', isi: 'Membuat kunci' },
      {
        t: 'p',
        isi: 'Buka Pengaturan, lalu API Key. Nilai penuhnya ditampilkan sekali saat dibuat, jadi simpanlah baik-baik. Kunci berlaku untuk seluruh organisasi Anda, bukan untuk satu orang.',
      },
      {
        t: 'kode',
        isi: `curl https://crawel.com/api/v1/jobs \\
  -H "Authorization: Bearer crwl_sk_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"`,
      },
      {
        t: 'catatan',
        nada: 'peringatan',
        isi: 'Perlakukan kunci API seperti kata sandi. Jangan menaruhnya di kode yang berjalan di peramban, di repositori publik, atau di tangkapan layar. Kalau terlanjur bocor, hapus kuncinya dari Pengaturan dan buat yang baru.',
      },
      { t: 'h', isi: 'Bentuk jawabannya' },
      {
        t: 'p',
        isi: 'Semua jawaban berhasil dibungkus dalam ruas data. Yang berupa daftar menambahkan ruas meta berisi informasi halaman.',
      },
      {
        t: 'kode',
        isi: `{
  "data": [ ... ],
  "meta": { "page": 1, "limit": 25, "total": 132 }
}`,
      },
      { t: 'h', isi: 'Yang paling sering dipakai' },
      {
        t: 'tabel',
        kepala: ['Endpoint', 'Untuk'],
        baris: [
          ['GET /jobs', 'Daftar pekerjaan scraping Anda'],
          ['POST /jobs', 'Membuat pekerjaan baru'],
          ['POST /jobs/:id/run', 'Menjalankan sekarang'],
          ['GET /jobs/:id/runs', 'Riwayat jalan beserta statusnya'],
          ['GET /jobs/:id/records', 'Baris hasil, berhalaman'],
          ['GET /jobs/:id/export', 'Seluruh hasil sebagai CSV'],
          ['GET /storage/files', 'Berkas di Penyimpanan Pribadi'],
          ['GET /storage/files/:id/download', 'Mengunduh satu berkas'],
          ['GET /datasets', 'Katalog Data Publik'],
          ['GET /analyses', 'Laporan hasil analisa'],
          ['GET /dashboard/usage', 'Sisa kuota Anda'],
        ],
      },
      { t: 'h', isi: 'Contoh: menarik hasil ke pandas' },
      {
        t: 'kode',
        isi: `import requests
import pandas as pd

KUNCI = "crwl_sk_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
BASIS = "https://crawel.com/api/v1"
kepala = {"Authorization": f"Bearer {KUNCI}"}

# Cari pekerjaannya
jobs = requests.get(f"{BASIS}/jobs", headers=kepala).json()["data"]
job = next(j for j in jobs if j["name"] == "Kutipan Harian")

# Tarik hasilnya, halaman demi halaman
baris, halaman = [], 1
while True:
    r = requests.get(
        f"{BASIS}/jobs/{job['id']}/records",
        headers=kepala,
        params={"page": halaman, "limit": 200},
    ).json()
    baris += [b["data"] for b in r["data"]]
    if halaman * 200 >= r["meta"]["total"]:
        break
    halaman += 1

df = pd.DataFrame(baris)
print(df.head())`,
      },
      { t: 'h', isi: 'Contoh: membuat pekerjaan baru' },
      {
        t: 'kode',
        isi: `curl -X POST https://crawel.com/api/v1/jobs \\
  -H "Authorization: Bearer crwl_sk_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" \\
  -H "Content-Type: application/json" \\
  -d '{
    "name": "Katalog Buku",
    "targetUrl": "https://books.toscrape.com/",
    "crawl": { "maxPages": 2, "itemSelector": "article.product_pod" },
    "fields": [
      { "name": "judul", "selector": "h3 a", "type": "text" },
      { "name": "harga", "selector": ".price_color", "type": "number" }
    ],
    "runNow": true
  }'`,
      },
      {
        t: 'catatan',
        nada: 'peringatan',
        isi: 'Jangan lupa itemSelector di dalam crawl. Tanpa itu, seluruh halaman dianggap satu item dan hasilnya cuma satu baris. Ini kekeliruan yang paling sering terjadi saat memakai API langsung.',
      },
      { t: 'h', isi: 'Kalau ada yang salah' },
      {
        t: 'tabel',
        kepala: ['Kode', 'Artinya', 'Yang perlu Anda lakukan'],
        baris: [
          ['400', 'Bentuk permintaan rusak', 'Periksa JSON-nya'],
          ['401', 'Kunci tidak ada atau salah', 'Periksa header Authorization'],
          ['403', 'Izin tidak mencukupi', 'Kunci API mengikuti izin organisasi Anda'],
          ['404', 'Tidak ditemukan', 'Periksa idnya'],
          ['409', 'Bentrok dengan keadaan sekarang', 'Misalnya menjalankan pekerjaan yang sedang berjalan'],
          ['422', 'Bentuk benar, isinya belum sah', 'Ruas details menyebut ruas mana yang salah'],
          ['429', 'Terlalu banyak permintaan', 'Beri jeda, lalu coba lagi'],
          ['402', 'Kuota habis', 'Naikkan paket atau tambah add-on'],
        ],
      },
      {
        t: 'kode',
        isi: `{
  "error": {
    "code": "QUOTA_EXCEEDED",
    "message": "Kuota 3.000 baris untuk periode ini sudah habis.",
    "details": { "limit": 3000, "used": 3000, "resource": "records" },
    "requestId": "3a0193e0-05c0-4599-aa0b-5232ff7d5433"
  }
}`,
      },
      {
        t: 'p',
        isi: 'Sertakan requestId saat melapor. Dengan nomor itu kami bisa menemukan kejadiannya dengan tepat.',
      },
      { t: 'h', isi: 'Batas permintaan' },
      {
        t: 'p',
        isi: 'Batasnya 120 permintaan per menit. Kalau Anda menarik data dalam jumlah besar, ambil per halaman dengan limit besar, bukan banyak permintaan kecil beruntun.',
      },
    ],
  },

  {
    id: 'masalah',
    judul: 'Kalau Ada Kendala',
    isi: [
      {
        t: 'p',
        isi: 'Sebagian besar kendala punya sebab yang sama. Coba cocokkan dengan daftar ini dulu.',
      },
      {
        t: 'tabel',
        kepala: ['Yang Anda lihat', 'Biasanya karena'],
        baris: [
          ['Hasil crawl kosong', 'Halamannya butuh JavaScript. Ganti mesin menjadi Browser'],
          ['Hasilnya cuma satu baris', 'itemSelector belum diisi, jadi seluruh halaman dianggap satu item'],
          ['Sebagian kolom kosong', 'Selektornya hanya cocok di sebagian item. Periksa lewat mode Manual'],
          ['Crawl ditolak sebelum jalan', 'Kuota habis, atau alamatnya tidak bisa dijangkau'],
          ['Jadwal tidak berjalan', 'Frekuensinya belum tersedia di paket Anda, atau jumlah jadwal sudah penuh'],
          ['Analisa tidak kunjung selesai', 'Kabari kami lewat Lapor Bug, sertakan nama analisanya'],
          ['Unduhan gagal', 'Muat ulang halamannya. Kalau masih, kabari kami'],
        ],
      },
      { t: 'h', isi: 'Menghubungi kami' },
      {
        t: 'p',
        isi: 'Pakai menu Lapor Bug di dalam dashboard. Yang paling membantu kami memperbaikinya cepat adalah langkah untuk mengulang kejadiannya. Peramban, versi aplikasi, dan halaman yang sedang Anda buka ikut terkirim otomatis, jadi Anda tidak perlu menuliskannya.',
      },
      {
        t: 'catatan',
        nada: 'peringatan',
        isi: 'Menemukan celah keamanan? Jangan melaporkannya lewat Lapor Bug, karena laporan di sana terlihat oleh semua admin di organisasi Anda. Kirimkan langsung ke kontak yang tercantum di halaman depan.',
      },
    ],
  },
];
